import getters from './getters';
import mutations from './mutations';

const diagramModule = {
  namespaced: true,
  state() {
    return {
      keypadNextButtonTableBubble: false,
      nextTableBubbleCellIndex: null,
      currentMeasurmentTableCell: null,
    };
  },
  getters,
  mutations,
};

export default diagramModule;
